/**
 * Online Order Form DB Service REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AdminRmaShipDevice { 
    rmaItemId: string;
    shippingDate: string;
    shippingOption: AdminRmaShipDevice.ShippingOptionEnum;
    shippedBy?: string;
    trackingId?: string;
}
export namespace AdminRmaShipDevice {
    export const ShippingOptionEnum = {
        Dhl: 'DHL',
        Ups: 'UPS',
        FedEx: 'FED_EX',
        Tnt: 'TNT',
        KuehneNagel: 'KUEHNE_NAGEL',
        DbSchenker: 'DB_SCHENKER',
        CollectedByCustomer: 'COLLECTED_BY_CUSTOMER',
        Other: 'OTHER'
    } as const;
    export type ShippingOptionEnum = typeof ShippingOptionEnum[keyof typeof ShippingOptionEnum];
}


export type ShippingOptionEnum = typeof AdminRmaShipDevice.ShippingOptionEnum[keyof typeof AdminRmaShipDevice.ShippingOptionEnum];
